export default "__VITE_ASSET__C7vDFG$b__"